import { Space, Spin } from "antd";


export const Loading = () => <Space style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '50vh' }}> <Spin size="large" /> </Space>
